import { useExamEventDetails } from '@exam-center/exam-event-management';
import { useGetExamEventParticipatedCoursesQuery } from '@exam-center/graphql';
import { useNavigate, useParams } from '@exam-center/router';
import { Flex, PaperSection } from '@shared/components';
import { adjustTime } from '@shared/utils';

import { useProctoringDetailsModal } from '../../providers';

import { SessionCardItem } from './session-card-item';

export default function ExamSessionList() {
  const navigate = useNavigate();
  const { examCenterCode, examEventId } = useParams(
    '/:examCenterCode/proctoring/exam-events/:examEventId/details',
  );
  const { examEvent } = useExamEventDetails();
  const { setAction } = useProctoringDetailsModal();

  const { data: participatedCoursesData, loading: participatedCoursesLoading } =
    useGetExamEventParticipatedCoursesQuery({
      variables: { input: { examEventId } },
      skip: !examEventId || examEvent.sessions.length <= 1,
      fetchPolicy: 'cache-first',
    });

  if (examEvent.sessions.length <= 1) {
    return null;
  }

  const sessions = [...examEvent.sessions];

  const participatedCourses =
    participatedCoursesData?.ecGetExamEventParticipatedCourses.examEventCourses ?? [];

  const onClickTimeExtension = (sessionId: string) => {
    setAction({ action: 'extend-time', data: { sessionId } });
  };

  const onClickTimeExtensionHistory = (sessionId: string) => {
    setAction({ action: 'time-extension-history', data: { sessionId } });
  };

  return (
    <PaperSection title='ช่วงการสอบ'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
          p: theme.spacing(6),
        })}
      >
        {sessions
          .sort((a, b) => a.round - b.round)
          .map((session) => {
            const onClickProctoring = () => {
              navigate(
                '/:examCenterCode/proctoring/exam-events/:examEventId/details/session/:examSessionId',
                {
                  params: {
                    examCenterCode: examCenterCode,
                    examEventId: examEventId,
                    examSessionId: session.id,
                  },
                },
              );
            };

            return (
              <SessionCardItem
                examRoundNumber={session.round}
                startTime={session.startedAt}
                endTime={session.endedAt}
                key={session.id}
                adjustedStarTime={adjustTime(session.startedAt, session.postponeDurationInMs ?? 0)}
                onClickProctoring={onClickProctoring}
                timeAdjustment={session.postponeDurationInMs ?? 0}
                timeExtension={{
                  loading: participatedCoursesLoading,
                  hidden: sessions.length <= 1,
                  currentSession: session,
                  participatedCourses,
                  onClick: () => onClickTimeExtension(session.id),
                }}
                timeExtensionHistory={{
                  loading: participatedCoursesLoading,
                  hidden: sessions.length <= 1,
                  currentSession: session,
                  participatedCourses,
                  onClick: () => onClickTimeExtensionHistory(session.id),
                }}
              />
            );
          })}
      </Flex>
    </PaperSection>
  );
}
